import { useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import Cookies from 'js-cookie';

const Settings = () => {
    const { base_url, company } = useAppContext();

    useEffect(() => {
        Cookies.set('company_id', company.company_id, { domain: '.slipstreamautomations.com', path: '/' });
    })

    return (
        <div>
            <div className="content-header">
                <h1>Connection Settings</h1>
                <p>Manage how Slipstream connects to HubSpot and QuickBooks.</p>
                <hr />
            </div>

            <div className="settings-grid">
                <div className="card">
                    <h3>HubSpot Connection</h3>
                    <hr />
                    <p>Manage your connection between Slipstream and HubSpot.</p>
                    <div className="settings-card-actions">
                        {/* <button className="btn btn-secondary">Disconnect</button> */}
                        <a href={`${base_url}/core/users/crm-oauth/HUB`} className="btn btn-primary">Re-Connect</a>
                    </div>
                </div>

                <div className="card">
                    <h3>QuickBooks Connection</h3>
                    <hr />
                    <p>Manage your connection between Slipstream and QuickBooks.</p>
                    <div className="settings-card-actions">
                        {/* <button className="btn btn-secondary">Disconnect</button> */}
                        <a href={`${base_url}/core/users/acct-oauth/QBO?req_type=reconnect`} className="btn btn-primary">Re-Connect</a>
                    </div>
                </div>

                {company.sec_acct_connected && (
                    <div className="card">
                        <h3>Secondary QBO Connection</h3>
                        <hr />
                        <p>Manage your connection between Slipstream and your secondary QuickBooks company.</p>
                        <div className="settings-card-actions">
                            {/* <button className="btn btn-secondary">Disconnect</button> */}
                            <a href={`${base_url}/core/users/acct-oauth-alt/QBO?req_type=reconnect`} className="btn btn-primary">Re-Connect</a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Settings;